<template>
  <div id="app">
    <!-- 路由内容显示区域 -->
    <router-view class="main-container"></router-view>
    <nav v-if="$route.meta.showNav" class="bottom-nav w3-bar w3-green" >
      <router-link to="/agentInfo" class="w3-bar-item w3-button">账号</router-link>
      <router-link to="/coinRecord" class="w3-bar-item w3-button">佣金记录</router-link>
      <router-link to="/userList" class="w3-bar-item w3-button">用户列表</router-link>
    </nav>
  </div>
</template>

<style>
#app {
  position: relative;
  min-height: 100vh; /* 确保容器撑满视口高度 */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
.main-content {
  padding-bottom: 60px; /* 底部导航高度 + 边距 */
}
/* 激活的导航链接样式 */
.router-link-active {
  background-color: #003366 !important;
}
/* 固定底部导航 */
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* 确保导航在最顶层 */
  box-shadow: 0 -2px 5px rgba(0,0,0,0.1); /* 顶部阴影效果 */
}
</style>